import React, { useRef, useState, useEffect, useImperativeHandle } from 'react';
import FilterBase, { IFilterBaseInstance } from '@/pages/intelligence/components/Filter/FilterBase';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import { onFilterConfirm } from '@intelligence/components/Filter/util';
export { onFilterConfirm };

/**
 * Filter组件实例
 */
export interface IFilterInstance extends IFilterBaseInstance { }

const Filter: React.ForwardRefRenderFunction<IFilterInstance, any> = (props, ref) => {
  const {
    inputList = [], // 筛选器列表
    showButton = true, // 是否显示操作按钮
    resetType, // undefined,'loading','disabled'  暂时未用到
    defaultValue = {},
    value,
    onChange,
    onConfirm,
    onReset,
    iconText,
    buttonText,
    isHaveFilterSave,
    isCustomLayoutFilter = false,
    filterSaveType = '',
    onToggleMoreFilter = () => { },
    resetTip,
    filterLoading = false,
    exportTableCom,
    onFilterLog,
    ...restProps
  } = props;

  // console.debug('Filter0000', props)

  const filterBaseRef = useRef<IFilterBaseInstance | null>(null);

  const [formValue, setFormValue] = useState(value);

  function filterKeys(obj: any, keys: string[]) {
    try {
      const result: any = {};
      Object.keys(obj).forEach((key) => {
        if (keys.includes(key)) {
          result[key] = obj[key];
        }
      });
      return result;
    } catch (err) {
      return obj;
    }
  }

  useEffect(() => {
    setFormValue(value);
  }, [JSON.stringify(value)]);

  const filterBaseConfirm = (val: any, isCustomLayoutFilter = false) => {
    // console.debug('Filter: valvalval', val);
    const filterListKeys = inputList?.map((t: any) => t?.key ?? t?.type);
    const result = filterKeys(val, filterListKeys);
    // console.debug('Filter: result', result, 'inputList', inputList);
    // 把没有展示的筛选器过滤掉；
    const { error, value, apiValue } = onFilterConfirm(result, inputList);
    //  console.debug('Filter: apiValue', apiValue);
    if (!error) {
      onConfirm(value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */, isCustomLayoutFilter);
    }
  };

  const onFilterChange = (key: string, value: any, newValue: any, isNoButtonMyFilter: boolean) => {
    // console.log('Filter: User changed filter - key:', key, 'value:', value, 'newValue:', newValue);

    // Log the user interaction immediately, before any cascading effects
    if (onFilterLog && typeof onFilterLog === 'function') {
      onFilterLog(key, value, newValue);
    }

    // Continue with normal flow
    onChange?.(key, value, newValue, isNoButtonMyFilter);
  };

  useImperativeHandle(ref, () => ({
    setValueAndConfirm: (partialValue: IRecord, options?: { resetToDefault?: boolean }) => {
      filterBaseRef.current?.setValueAndConfirm(partialValue, options);
    },
  }));

  return (
    <Abnormal
      isLoading={filterLoading}
      style={{ height: 92 }}
      component={
        <FilterBase
          ref={filterBaseRef}
          {...restProps}
          value={formValue}
          defaultValue={defaultValue}
          inputList={inputList}
          onChange={onFilterChange}
          onConfirm={filterBaseConfirm}
          onToggleMoreFilter={onToggleMoreFilter}
          onReset={onReset}
          resetTip={resetTip}
          iconText={iconText}
          showButton={showButton}
          buttonText={buttonText}
          isHaveFilterSave={isHaveFilterSave}
          isCustomLayoutFilter={isCustomLayoutFilter}
          filterSaveType={filterSaveType}
          exportTableCom={exportTableCom}
        />
      }
    />
  );
};

export default React.forwardRef(Filter);
